import { Directive, AfterViewInit, inject, Input, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appUppercaseValue]',
    standalone: false
})
export class UppercaseValueDirective implements AfterViewInit {
  @Input('appUppercaseValue') enabled?: boolean = false;

  private ngControl = inject(NgControl);
  private destroyRef = inject(DestroyRef);

  ngAfterViewInit(): void {
    if (this.enabled && this.ngControl?.valueChanges) {
      this.ngControl.valueChanges
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((value: string) => {
          if (typeof value === 'string') {
            const upperValue = value.toUpperCase();
            if (value !== upperValue) {
              this.ngControl.control?.setValue(upperValue, { emitEvent: false });
            }
          }
        });
    }
  }
}